import {
  SbBlokData,
  storyblokEditable,
  StoryblokComponent,
} from "@storyblok/react"
import { createUseStyles } from "react-jss"

// Generic layout wrapper. Renders its nested bloks inside a <div> whose
// dimensions are driven entirely by CMS fields (raw CSS values, same
// convention as the Button blok). Every field is optional — an empty field
// applies no style, so an unconfigured Container is a transparent passthrough.
export interface IContainerProps {
  width?: string
  maxWidth?: string
  margin?: string
  padding?: string
  display?: string
}

export interface IContainerBlok extends SbBlokData, IContainerProps {
  blocks?: SbBlokData[]
}

const useStyles = createUseStyles<string, IContainerProps>({
  root: {
    width: ({ width }) => width || undefined,
    maxWidth: ({ maxWidth }) => maxWidth || undefined,
    margin: ({ margin }) => margin || undefined,
    padding: ({ padding }) => padding || undefined,
    display: ({ display }) => display || undefined,
  },
})

export default function Container({ blok }: { blok: IContainerBlok }) {
  const { blocks, width, maxWidth, margin, padding, display } = blok

  const classes = useStyles({ width, maxWidth, margin, padding, display })

  return (
    <div className={classes.root} {...storyblokEditable(blok)}>
      {blocks?.map((nestedBlok) => (
        <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
      ))}
    </div>
  )
}
